export const isValidPrinterAddress = data => {
    if (data.PrinterType === 'godex') {
        let godexIPRegex = /^([0-9]{1,3}\.){3}[0-9]{1,3}:[0-9]+$/igm;
        return godexIPRegex.test(data.URI);
    }
    let URI = data.URI.split(':');
    let zebraRegex = /^([0-9]{1,3}\.){3}[0-9]{1,3}?$/igm;
    return zebraRegex.test(URI[0]);
}